import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginPage from "../pages/login/page";
import GamesPage from "../pages/games/page";
import GameDetailPage from "../pages/games/detail/page";
import KnowledgePage from "../pages/knowledge/page";
import CommunityPage from "../pages/community/page";
import TeacherPage from "../pages/teacher/page";
import AboutPage from "../pages/about/page";
import AdminLoginPage from "../pages/admin/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AuthCallbackPage from "../pages/auth/callback/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/auth/callback", element: <AuthCallbackPage /> },
  { path: "/games", element: <GamesPage /> },
  { path: "/games/:id", element: <GameDetailPage /> },
  { path: "/knowledge", element: <KnowledgePage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/teacher", element: <TeacherPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/admin", element: <AdminLoginPage /> },
  { path: "/admin/dashboard", element: <AdminDashboard /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
